export const ConvertText = function(input){
  let wrapProcess = function(str) {
    return "@@" + str + "@@"
  };

  let blankRegex = /_(.*?)_/g

  let choiceRegex = /\[(.*?)\]/g

  let lineBreaks = /\n\n*/g

  let text = input;

  let rules = [blankRegex, choiceRegex]


  rules.forEach((rule)=>{
    text = text.replace(rule, wrapProcess)
  })
  text = text.replace(lineBreaks, "\n")

  let paragraphList = text.split("\n")
  let paragraphs = []


  paragraphList.forEach((paragraph)=>{
    let processInputList = paragraph.split("@@")

    let processList = []

    processInputList.forEach((input)=>{
      let currentItem = {
        value:""
      }

      if(blankRegex.test(input)){
        currentItem.type = "blank"
        currentItem.defaultValue = input.replace(/_/g,"")
        currentItem.value = currentItem.defaultValue
      }
      else if(choiceRegex.test(input)){
        currentItem.type = "choice"
        currentItem.choices = input.replace(/\[|\]/g,"").split("|")
        currentItem.value = currentItem.choices[0]
      }
      else{
        currentItem.type = "text"
        currentItem.value = input
      }

      processList.push(currentItem);
    })
    paragraphs.push(processList);
  })

  return paragraphs
}

export const EncodeUrlComponent = function(input){
  return btoa(input)
}



// WEBPACK FOOTER //
// ./src/Functions.js